// extracted by mini-css-extract-plugin
module.exports = {"inputField":"PercentageInput_inputField__2HWIA","inputLabel":"PercentageInput_inputLabel__1uoX4"};